<template>
  <modal-brandme :show_modal="open_modal_login" :size="'lg'">
    <template #body>
      <video
        class="w-100"
        :src="asset_url"
        @error="errorLoad(uuid_img)"
        :autoplay="false"
        :loop="true"
        controls
        controlsList="nodownload"
        ref="video"
        v-if="type_content === 'video'"
      ></video>
      <b-img
        class="w-100"
        :src="asset_url"
        @error="errorLoad(uuid_img)"
        v-if="type_content === 'image'"
      />
      <div v-if="download" class="d-flex justify-content-center">
        <b-button class="blue-button mt-2" variant="blue-button" @click="downloadAsset">
          {{  $t('campaigns.download_content') }}
        </b-button>
    </div>
    </template>
  </modal-brandme>
</template>

<script>
import {
  BImg,BButton
} from 'bootstrap-vue';
import modalBrandme from '@/views/components/modal/ModalBrandme.vue';
import service_campaign from "@/services/campaign";

export default {
  name: 'ModalContent',
  components: {
    BButton,
    modalBrandme,
    BImg
  },
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    asset_url: {
      type: String,
    },
    type_content: {
      type: String,
      default: '',
    },
    download: {
      type: Boolean,
      default: false,
    },
    uuid_img: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      open_modal_login: this.open_modal,
    }
  },
  computed: {
  },
  methods: {
    errorLoad(uuid_img) {
      service_campaign.getImageUpdatedContent(uuid_img).then((response) => {
        const img_new = response.image_content;
        this.asset_url = img_new;
      });
    },
    downloadAsset() {
      if (this.type_content === 'image') {
        window.open(this.asset_url, '_blank');
      } else {
        const link = document.createElement('a');
        link.href = this.asset_url;

        const filename = this.asset_url.split('/').pop() || 'archivo';

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
}
</script>

<style scoped>

</style>